// extracted by mini-css-extract-plugin
module.exports =  {"updater-banner":"updater-banner-MjMLN","button":"button-ixcOU","close":"close-Quid9","icon":"icon-N2Lyd"};